module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAA/UlEQVRIx2M4J6hGI8QwavQgNfpepML7FVK3PBWpbPRFGdVrZspPa2S/7JcAWkA1o68aqDyrkQUiIOOqscrXg+K33BSpY/R5EdUP6yWBCMgAcp9Uyn5YI0kdo295Kd6wVgaic0Ig7jVz5U+bJC8qqeIzmkjw/pxofCAHnGuoxXJmvZCYMBMD5aAxn/vRIRFvR3YItz6X++hKQQZqgcRgzivbhIuTudSUmO/tF3axZqOCoZtnCaycxA80y9KAdXYb35I+vq5yXuq419Gc9chKoTMbhIDhu2kmv5kea08Fj7M1K9UCBBhp8Hjj5GBsyOcO9+ZgoBHQUmFhGAVEAwDhQl3VCgivpAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/ao.png
// module id = 771
// module chunks = 0